import ScrollTrigger from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';
import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';

export function initChipCards(parent) {
  if (!parent) return;

  const list = parent.querySelector('.chip-cards__list');
  const items = parent.querySelectorAll('.chip-cards__item');

  const mainTl = gsap.timeline({
    scrollTrigger: {
      trigger: list,
      start: 'top 75%',
      toggleActions: 'play none none none',
    },
  });
  mainTl.fromTo(
    list,
    { opacity: 0 },
    {
      opacity: 1,
      duration: 1,
      ease: 'power1.inOut',
    },
    '0',
  );

  items.forEach((item, index) => {
    const card = item.querySelector('.chip-cards__card');
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({});
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
    mainTl.add(tl, index * 0.1);

    const animationTopRightEl = card.querySelector(
      '.chip-cards__animation-top-right',
    );
    let animationTopRight;
    if (animationTopRightEl) {
      animationTopRight = new ParticleWaveBackground(animationTopRightEl, {
        planeWidth: 8.379,
        planeHeight: 7.904,
        widthSegments: 20,
        heightSegments: 40,
        particleSize: 0.15,
        waveHeight: 0.3,
        noiseScale: 2,
        animationSpeed: 8000,
        gradient: [
          { color: '#fcbcae', stop: 0 },
          { color: '#f5f5f500', stop: 100 },
        ],
        rotation: {
          x: -0.439822971502571,
          y: -0.314159265358979,
          z: 0.502654824574367,
        },
        cameraPosition: [-6.6, -2.2, 4.617],
        cameraRotation: { x: 0, y: 0, z: 0 },
        autoStart: true,
        hoverRadius: 1,
        hoverStrength: 0.5,
        hoverSpringStiffness: 40,
        hoverSpringDamping: 10,
      });
    }

    const animationTopLeftEl = card.querySelector(
      '.chip-cards__animation-top-left',
    );
    let animationTopLeft;
    if (animationTopLeftEl) {
      animationTopLeft = new ParticleWaveBackground(animationTopLeftEl, {
        planeWidth: 14,
        planeHeight: 14,
        widthSegments: 20,
        heightSegments: 40,
        particleSize: 0.14,
        waveHeight: 0.3,
        noiseScale: 4,
        animationSpeed: 5000,
        gradient: [
          { color: '#fcbcae', stop: 0 },
          { color: '#f5f5f500', stop: 100 },
        ],
        rotation: { x: -0.6, y: 0.09, z: -0.999026463841554 },
        cameraPosition: [5.44, -5.04, 11.818],
        cameraRotation: { x: 0, y: 0, z: 0 },
        autoStart: true,
        hoverRadius: 1,
        hoverStrength: 0.5,
        hoverSpringStiffness: 40,
        hoverSpringDamping: 10,
      });
    }

    if (animationTopRight || animationTopLeft) {
      ScrollTrigger.create({
        trigger: card,
        start: 'top bottom',
        end: 'bottom top',
        onEnter: () => {
          if (animationTopRight) animationTopRight.startAnimation();
          if (animationTopLeft) animationTopLeft.startAnimation();
        },
        onLeave: () => {
          if (animationTopRight) animationTopRight.stopAnimation();
          if (animationTopLeft) animationTopLeft.stopAnimation();
        },
        onEnterBack: () => {
          if (animationTopRight) animationTopRight.startAnimation();
          if (animationTopLeft) animationTopLeft.startAnimation();
        },
        onLeaveBack: () => {
          if (animationTopRight) animationTopRight.stopAnimation();
          if (animationTopLeft) animationTopLeft.stopAnimation();
        },
      });
    }
  });
}

export function initAllChipCards(selector = '.js-chip-cards') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initChipCards(block));
}
